
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { get } from 'lodash';

import { ModalAvailabilityStatus, Type } from '@components';
import { BookingErrorsEnum } from '@share/common-types';
import { IPackageRoom } from '@common-types';
import { RootState } from '@share/utils';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean;
  isDetails?: boolean;
  isGetaways?: boolean;
}

export function AvailabilityStatusModal(props: IProps) {
  const { isVacationRentals, isDetails, isGetaways } = props;

  const reviewBookStore = useSelector((state: RootState) => state.reviewBookStore);
  const hotelDetailsStore = useSelector((state: RootState) => state.hotelDetailsStore);

  const { bookingSummary } = reviewBookStore;
  const { error, hotel } = hotelDetailsStore;

  const rooms = useMemo(() => get(bookingSummary, 'bookingCard.package.rooms', []), [bookingSummary]);
  const hasSoldout = useMemo(() => rooms.filter((r: IPackageRoom) => r.availability === BookingErrorsEnum.SoldOut).length > 0, [rooms]);
  const hasUnavailable = BookingErrorsEnum.RoomsUnavailable === error;
  
  return (
    <ModalAvailabilityStatus
      hasSoldout={hasSoldout}
      isUnavailable={hasUnavailable}
      type={isGetaways ? Type.GETAWAYS_HOTELS : isVacationRentals ? Type.VACATION_RENTALS : Type.HOTELS}
      propertyId={hotel?.hotelDetails?.id?.toString()}
      bookingErrorCode={error}
      isDetails={isDetails}
    />
  );
}
